import { render, staticRenderFns } from "./RegistrationGettingStarted.vue?vue&type=template&id=4dc0554c&scoped=true"
import script from "./RegistrationGettingStarted.vue?vue&type=script&lang=js"
export * from "./RegistrationGettingStarted.vue?vue&type=script&lang=js"
import style0 from "./RegistrationGettingStarted.vue?vue&type=style&index=0&id=4dc0554c&prod&scoped=true&lang=css"
import style1 from "./RegistrationGettingStarted.vue?vue&type=style&index=1&id=4dc0554c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc0554c",
  null
  
)

export default component.exports